import { render, staticRenderFns } from "./CollegeSetting.vue?vue&type=template&id=3d20bbd5&scoped=true"
import script from "./CollegeSetting.vue?vue&type=script&lang=js"
export * from "./CollegeSetting.vue?vue&type=script&lang=js"
import style0 from "./CollegeSetting.vue?vue&type=style&index=0&id=3d20bbd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d20bbd5",
  null
  
)

export default component.exports